import { Truck, Wrench } from 'lucide-react';

export const ASSET_GROUPS = {
  fleet: {
    key: 'fleet', group: 'vehicles', kind: 'vehicle', statsKey: 'vehicles',
    title: 'Parc Auto', singular: 'Vehicul', writePerm: 'fleet.write', readPerm: 'fleet.read',
    icon: Truck, meterField: 'odometer_km', meterLabel: 'Kilometraj', meterUnit: 'km', useMeterType: false,
    docTypes: ['ITP', 'RCA', 'CASCO', 'Rovinietă', 'Leasing', 'Tahograf', 'Copie conformă', 'Autorizație transport'],
  },
  equipment: {
    key: 'equipment', group: 'equipment', kind: 'equipment', statsKey: 'equipment',
    title: 'Utilaje', singular: 'Utilaj', writePerm: 'equipment.write', readPerm: 'equipment.read',
    icon: Wrench, meterField: 'meter_value', meterLabel: 'Contor', meterUnit: '', useMeterType: true,
    docTypes: ['ISCIR', 'RSVTI', 'Verificare tehnică', 'Autorizație', 'Certificat', 'Asigurare', 'Leasing'],
  },
};

export const STATUS_META = {
  disponibil: { label: 'Disponibil', cls: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20' },
  in_lucru: { label: 'În lucru', cls: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  service: { label: 'Service', cls: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  indisponibil: { label: 'Indisponibil', cls: 'text-rose-400 bg-rose-500/10 border-rose-500/20' },
};

export const OWNERSHIP = { proprietate: 'Proprietate', leasing: 'Leasing', inchiriere: 'Închiriere' };

export const DOC_STATE = {
  ok: 'Documente valide', expiring: 'Expiră în 30 zile', expired: 'Document expirat', none: 'Fără termene',
};

export const COST_TYPES = ['combustibil', 'adblue', 'service', 'piese', 'anvelope', 'asigurare',
  'taxe', 'leasing', 'amenzi', 'reparatii', 'spalare', 'gps', 'altele'];
